import {FC, memo} from 'react';
import {Box, Center, Flex} from '@chakra-ui/react';
import {EDocumentApiStatus, IDocumentInfo, isDelayedApiStatus} from '@kcast-fe/core';
import {Loader, Svg} from 'ui-kit';

interface IProps {
  document: IDocumentInfo;
  isDeleting: boolean;
  isUploading: boolean;
  isProcessing: boolean;
  maxWidthPx: number;
  progress: number;
  onDelete: () => void;
}

const DocumentItemFC: FC<IProps> = ({
  document,
  progress,
  maxWidthPx,
  isDeleting,
  isUploading,
  isProcessing,
  onDelete
}) => {
  const isFailed = document.api_status === EDocumentApiStatus.Failed;
  const isDelayed = isDelayedApiStatus(document.api_status);

  return (
    <Flex
      h={'32px'}
      position={'relative'}
      alignItems={'center'}
      p={'4px 6px 4px 12px'}
      bg={isFailed ? '{colors.stateError}' : '{colors.textPrimary}'}
      borderRadius={'16px'}
      color={'{colors.white}'}
    >
      {/* UPLOAD PROGRESS */}
      <Box
        h={'100%'}
        w={'100%'}
        overflow={'hidden'}
        position={'absolute'}
        borderRadius={'16px'}
        zIndex={1}
        left={0}
        top={0}
      >
        {(isUploading || isProcessing) && (
          <Box
            h={'100%'}
            bg={'{colors.textPrimarySuperLight}'}
            transition={'all var(--tr-500-ei-eo)'}
            transform={`scaleX(${progress})`}
            transformOrigin={'left center'}
          />
        )}
      </Box>

      <Flex position={'relative'} alignItems={'center'} gap={'4px'} zIndex={2}>
        <Box
          fontSize={'16px'}
          maxW={`${maxWidthPx}px`}
          opacity={isDeleting ? 0.5 : 1}
          className={'cut-text'}
        >
          {document.title}
        </Box>
        <Center w={'24px'}>
          {isDeleting || isUploading || isProcessing || isDelayed ? (
            <Loader size={'sm'} />
          ) : (
            <Svg name={'Close'} onClick={onDelete} />
          )}
        </Center>
      </Flex>
    </Flex>
  );
};

export const DocumentItem = memo(DocumentItemFC);
